import { RATE_DRAWER_DEFAULT } from "us.collection.admin/constants";
import { StandardRates } from "us.collection.admin/interfaces";

export const initialState: StandardRates = {
  rates: {
    isLoading: false,
    data: [],
  },
  ratesHistory: {
    isLoading: false,
    data: [],
  },
  isStandardRateDeleting: false,
  isStandardRateSaving: false,
  drawerInfo: RATE_DRAWER_DEFAULT,
};
